@if (googleMapsReady()) {
  <section class="mn_map_view">
    <div class="contmap" style="overflow: hidden">
      <google-map
        #map
        [center]="center()"
        [zoom]="zoom()"
        [options]="options()"
        (zoomChanged)="onZoomChanged()"
        height="100%"
        width="100%">
      </google-map>
    </div>
  </section>
}
